<script>
    import Fa from 'svelte-fa';
    import { faArrowUpFromBracket, faSquarePlus } from '@fortawesome/pro-regular-svg-icons';

    import { onDestroy } from 'svelte';
    import { browser } from '$app/environment';
    import { pwaInstallPrompt, alreadyInstalled } from '$lib/utils/pwa';
    import device from '$lib/utils/functions/device';

    import Modal from './Modal.svelte';

    export let autoPrompt = false;

    let prompt = undefined;
    let installed = undefined;

    const unsubscribePrompt = pwaInstallPrompt.subscribe((value) => (prompt = value));
    const unsubscribeInstalled = alreadyInstalled.subscribe((value) => (installed = value));

    // Automatically trigger the prompt if we want, just pass autoPrompt prop in
    $: if (prompt && autoPrompt) {
        prompt.prompt();
    }

    // Unsubscribe the store listeners
    onDestroy(() => {
        unsubscribePrompt();
        unsubscribeInstalled();
    });

    // Get User Agent
    let userAgent;
    if (browser) {
        userAgent = device.getUserAgent();
    }

    // iOS Instruction Popup
    $: showIosInstructions = false;

    // Test variable for localhost (comment out when pushed) - true for android / false for iOS
    // prompt = false;
</script>

{#if !installed && !autoPrompt}
    <div class="flex justify-center md:hidden">
        {#if prompt}
            <!-- Android Install -->
            <button
                class="flex items-center gap-2 rounded-xl border border-base-900/5 bg-base-900 bg-opacity-60 px-4 py-2 shadow-sm"
                on:click={prompt.prompt()}
            >
                <div><img class="mr-2 inline-block h-8 w-8 flex-none justify-start" alt="Google Logo" src="/svg/android.svg" /></div>
                <div class="grow text-left">
                    <span class="block text-xs">Install our app on your</span>
                    <span class="block text-lg font-semibold">Android Phone</span>
                </div>
            </button>
        {:else if !prompt && userAgent === 'iOS'}
            <!-- iOS Install -->
            <button
                class="items-center gap-2 rounded-xl border border-base-900/5 bg-base-900 bg-opacity-60 px-4 py-2 shadow-sm"
                id="installInstructions"
                on:click={() => (showIosInstructions = !showIosInstructions)}
            >
                <div><img class="mr-2 inline-block h-8 w-7 flex-none justify-start dark:invert" alt="Google Logo" src="/svg/apple.svg" /></div>
                <div class="grow text-left">
                    <span class="block text-xs">Install our app on your</span>
                    <span class="block text-lg font-semibold">iPhone</span>
                </div>
            </button>

            <Modal name="iosInstructions" modalOpen={showIosInstructions}>
                <div class="h-[60vh]">
                    <div class="mb-8 flex items-center gap-4">
                        <img class="mr-2 inline-block h-8 w-7 flex-none justify-start dark:invert" alt="Google Logo" src="/svg/apple.svg" />
                        <div class="grow">
                            <span class="block text-lg font-semibold dark:text-purple-300">Install our App</span>
                            <span class="block text-sm">To install this app on your iPhone</span>
                        </div>
                    </div>
                    <div class="mb-8 flex items-center gap-8">
                        <div><Fa icon={faArrowUpFromBracket} size="1.5x" class="text-blue-500" /></div>
                        <div class="grow">1. Press the 'Share' button</div>
                    </div>
                    <div class="flex items-center gap-8">
                        <div><Fa icon={faSquarePlus} size="1.5x" /></div>
                        <div class="grow">2. Press 'Add to Home Screen'</div>
                    </div>
                </div>
            </Modal>

            <style>
                #installInstructions {
                    display: none;
                }
                @media (display-mode: browser) {
                    #installInstructions {
                        display: flex;
                    }
                }
            </style>
        {/if}
    </div>
{/if}
